import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function ProductionChefLevel2() {
  return (
    <>
      <Header />
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk2.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          <div className="container" style={{ position: 'relative', zIndex: 2 }}>
            <div className="row">
              <div className="col-lg-10 mx-auto text-center">
                <div style={{
                  backgroundColor: 'rgba(123, 63, 158, 0.15)',
                  backdropFilter: 'blur(10px)',
                  borderRadius: '24px',
                  padding: '60px 50px 40px',
                  color: 'white'
                }}>
                  <h2 style={{ fontSize: '2.5rem', fontWeight: '700', marginBottom: '10px', textShadow: '0 2px 10px rgba(123, 63, 158, 0.97)', color: '#fff' }}>
                    Production Chef Level 2 Apprenticeship
                  </h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: 0, opacity: 0.95 }}>
                    ST0589 - Large-Scale Culinary Excellence
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Main Content Section */}
        <section id="production-chef-level-2" className="production-chef section" style={{ padding: '80px 0' }}>
          <div className="container" data-aos="fade-up">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  
                  {/* Title */}
                  <div className="text-center mb-5">
                    <h3 style={{ color: '#7B3F9E', fontSize: '2rem', fontWeight: '700', marginBottom: '10px' }}>
                      Production Chef Level 2 APPRENTICESHIP ST0589
                    </h3>
                  </div>

                  {/* Occupation Summary */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      Occupation summary
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      This occupation is found in a diverse range of organisations including high street and pub casual dining, the armed forces, schools, hospitals and care homes, work canteens, maritime, and more.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      The broad purpose of this occupation is to work with centrally developed standardised recipes, menus, and methods. Production chefs primarily pre-prepared ingredients often in high-volume bulk. A production chef works as part of a large team for a multi-site business. Production chefs cater to the culinary needs of elderly people in care homes, or people who are unwell or recovering from illness in hospitals.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      In their daily work, an employee in this occupation interacts with the kitchen team, a front of house team, suppliers, and, in some environments, customers. Production Chefs typically report to a senior production chef or a kitchen manager.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      An employee in this occupation will be responsible for producing dishes using majority pre-prepared ingredients, including some fresh e.g. salad and some frozen dishes e.g. lasagne. Production chefs work as part of a large team as they work within a limited capacity by following standardised recipes and specifications to ensure compliance. They work with a high level of consistency using organisational skills, energy, accuracy, attention to detail and are mindful of the impact of sustainability and protecting the environment. They are responsible for following standard operating procedures and centrally agreed menus and specifications to produce food on time and often in bulk. They are responsible for following instructions and guidelines on hygiene, health and safety, food safety, and fire regulations. They must also observe equity, diversity, inclusion and wellbeing guidelines and sustainability best practice.
                    </p>
                  </div>

                  {/* Typical Job Titles */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      Typical job titles include:
                    </h4>
                    
                    <div style={{ 
                      padding: '20px', 
                      backgroundColor: '#f8f9fa', 
                      borderRadius: '12px',
                      marginBottom: '20px'
                    }}>
                      <p style={{ color: '#495057', fontSize: '1.1rem', marginBottom: 0 }}>
                        <strong>Chef, Junior chef, Production chef</strong>
                      </p>
                    </div>

                    <div className="alert" style={{ 
                      backgroundColor: '#fff3cd', 
                      border: '1px solid #ffc107', 
                      borderRadius: '8px', 
                      padding: '20px'
                    }}>
                      <p style={{ color: '#856404', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: 0 }}>
                        If you meet most of these responsibilities as part of your existing role, or if you could be supported to meet these responsibilities during your apprenticeship, you could be suitable for this programme.
                      </p>
                    </div>
                  </div>

                  {/* Role Requirements */}
                  <div className="mb-5">
                    <ul style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '30px' }}>
                      <li style={{ marginBottom: '12px' }}>Is your role in a kitchen and are you part of a team?</li>
                      <li style={{ marginBottom: '12px' }}>Required to understand food legislation relating to COSHH, HACCP and health and safety?</li>
                      <li style={{ marginBottom: '12px' }}>Required to know how to handle and store ingredients in line with food safety requirements?</li>
                      <li style={{ marginBottom: '12px' }}>Required to follow organisational procedures for allergen control?</li>
                      <li style={{ marginBottom: '12px' }}>Required to understand how to adapt dishes to meet specific dietary and religious needs?</li>
                      <li style={{ marginBottom: '12px' }}>Required to prepare and cook a variety of meat, poultry, fish and vegetable dishes?</li>
                    </ul>
                  </div>

                  {/* The Modules */}
                  <div className="mb-5 p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '12px' }}>
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      The modules
                    </h4>
                    <ul style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '30px' }}>
                      <li style={{ marginBottom: '10px' }}>Self-management</li>
                      <li style={{ marginBottom: '10px' }}>Equipment</li>
                      <li style={{ marginBottom: '10px' }}>Teamwork and communication</li>
                      <li style={{ marginBottom: '10px' }}>Safety and legislation</li>
                      <li style={{ marginBottom: '10px' }}>Produce and present dishes</li>
                      <li style={{ marginBottom: '10px' }}>Adapt and modify</li>
                      <li style={{ marginBottom: '10px' }}>Kitchen management</li>
                      <li style={{ marginBottom: '10px' }}>Stock control</li>
                      <li>Problem-solving</li>
                    </ul>
                  </div>

                  {/* Qualifications */}
                  <div className="mb-5">
                    <h3 style={{ color: '#7B3F9E', fontSize: '1.8rem', fontWeight: '700', marginBottom: '20px' }}>
                      Qualifications
                    </h3>

                    {/* English and Maths */}
                    <div className="mb-4">
                      <h4 style={{ color: '#495057', fontSize: '1.4rem', fontWeight: '600', marginBottom: '15px' }}>
                        English and Maths
                      </h4>
                      <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                        The completion of English and maths qualifications are optional. The opportunity to complete these is available during the apprenticeship if the apprentice and employer agree.
                      </p>
                    </div>
                  </div>

                  {/* Blended Delivery */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px' }}>
                      Blended delivery
                    </h4>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      1:1 facilitated learning sessions with Learning Coach. Face-to-face and remote teaching and self-study.
                    </p>
                  </div>

                  {/* End Point Assessment */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '15px' }}>
                      End point assessment
                    </h4>
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      75-minute multiple choice test, 3-hour Practical Observation with questions, and 60-minute professional discussion.
                    </p>
                  </div>

                  {/* End-point Assessment Summary */}
                  <div className="mb-5 p-4" style={{ backgroundColor: '#e7f3ff', border: '1px solid #b3d9ff', borderRadius: '12px' }}>
                    <h4 style={{ color: '#0066cc', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      End-point assessment summary
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      This is a summary of the key things that you – the apprentice and your employer need to know about your end-point assessment (EPA). You and your employer should read the EPA plan for the full details. It has information on assessment method requirements, roles and responsibilities, and re-sits and re-takes.
                    </p>

                    <h5 style={{ color: '#0066cc', fontSize: '1.3rem', fontWeight: '600', marginBottom: '15px', marginTop: '25px' }}>
                      What is an end-point assessment and why it happens
                    </h5>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      An EPA is an assessment at the end of your apprenticeship. It will assess you against the knowledge, skills, and behaviours (KSBs) in the occupational standard. Your training will cover the KSBs. The EPA is your opportunity to show an independent assessor how well you can carry out the occupation you have been trained for.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      Your employer will choose an end-point assessment organisation (EPAO) to deliver the EPA. Your employer and training provider should tell you what to expect and how to prepare for your EPA.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      The length of the training for this apprenticeship is typically 12 months. The EPA period is typically 3 months.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px', fontStyle: 'italic' }}>
                      The overall grades available for this apprenticeship are:
                    </p>

                    <ul style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '30px', marginBottom: '15px' }}>
                      <li>fail</li>
                      <li>pass</li>
                      <li>merit</li>
                      <li>distinction</li>
                    </ul>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                      When you pass the EPA, you will be awarded your apprenticeship certificate.
                    </p>
                  </div>

                  {/* EPA Gateway */}
                  <div className="mb-5 p-4" style={{ backgroundColor: '#f8f9fa', borderRadius: '12px' }}>
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      EPA gateway
                    </h4>
                    
                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px' }}>
                      The EPA gateway is when the EPAO checks and confirms that you have met any requirements required before you start the EPA. You will only enter the gateway when your employer says you are ready.
                    </p>

                    <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '15px', fontWeight: '600' }}>
                      The gateway requirements for your EPA are:
                    </p>

                    <ul style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8', paddingLeft: '30px' }}>
                      <li style={{ marginBottom: '10px' }}>achieved English and mathematics qualifications in line with the apprenticeship funding rules</li>
                      <li>for the interview underpinned by a portfolio of evidence, you must submit a portfolio of evidence</li>
                    </ul>
                  </div>

                  {/* Assessment Methods */}
                  <div className="mb-5">
                    <h4 style={{ color: '#7B3F9E', fontSize: '1.5rem', fontWeight: '600', marginBottom: '20px' }}>
                      Assessment methods
                    </h4>

                    <div className="mb-4 p-3" style={{ backgroundColor: '#fff', border: '1px solid #dee2e6', borderRadius: '8px' }}>
                      <h5 style={{ color: '#495057', fontSize: '1.3rem', fontWeight: '600', marginBottom: '15px' }}>
                        Observation with questions
                      </h5>
                      <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                        You will be observed by an independent assessor completing your work. It will last at least 2 hours. They will ask you at least 3 questions.
                      </p>
                    </div>

                    <div className="p-3" style={{ backgroundColor: '#fff', border: '1px solid #dee2e6', borderRadius: '8px' }}>
                      <h5 style={{ color: '#495057', fontSize: '1.3rem', fontWeight: '600', marginBottom: '15px' }}>
                        Interview underpinned by a portfolio of evidence
                      </h5>
                      <p style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                        You will have an interview with an independent assessor. It will last at least 60 minutes. They will ask you at least 10 questions. The questions will be about certain aspects of your occupation. You need to compile a portfolio of evidence before the EPA gateway. You can use it to help answer the questions.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default ProductionChefLevel2;